export const DISBURSEMENT_TYPE = {
  ADVANCE: 'advance'
} as const

export type DisbursementType = (typeof DISBURSEMENT_TYPE)[keyof typeof DISBURSEMENT_TYPE]

export const DISBURSEMENT_TYPE_LABELS: Record<DisbursementType, string> = {
  [DISBURSEMENT_TYPE.ADVANCE]: 'Advance disbursement'
}

export const DISBURSEMENT_STEP_ID = {
  SELECT_TRADER: 'select-trader',
  SELECT_ITEMS: 'select-items',
  REVIEW: 'review'
} as const

export type DisbursementStepId = (typeof DISBURSEMENT_STEP_ID)[keyof typeof DISBURSEMENT_STEP_ID]

const ADVANCE_STEP_ORDER: DisbursementStepId[] = [
  DISBURSEMENT_STEP_ID.SELECT_TRADER,
  DISBURSEMENT_STEP_ID.SELECT_ITEMS,
  DISBURSEMENT_STEP_ID.REVIEW
]

export function getDisbursementStepOrder(disbursementType: DisbursementType | null): DisbursementStepId[] {
  void disbursementType
  return ADVANCE_STEP_ORDER
}

export const DISBURSEMENT_STEP_LABELS: Record<DisbursementStepId, string> = {
  [DISBURSEMENT_STEP_ID.SELECT_TRADER]: 'Trader',
  [DISBURSEMENT_STEP_ID.SELECT_ITEMS]: 'Select items',
  [DISBURSEMENT_STEP_ID.REVIEW]: 'Review & disburse'
}
